export default __webpack_public_path__ + "static/Onlinestore-4b4803b5d2fbea73c11ee99ecd333ff5.jpg";